// extracted by mini-css-extract-plugin
export default {"wrapper":"FuuS4mLCwuNpC7am0nwd","frame":"v56FXfvL8BavNYu69NzE"};